
import { createReducer } from '../utils/misc';
import {
    SALES_DRAWER
} from '../constants/index';

const initialState = {
    currentView: 'clients'
};

export default createReducer(initialState, {
    
    [SALES_DRAWER]: (state, payload) =>
        Object.assign({}, state, {
            currentView: payload.view,
        }),
    })


// WEBPACK FOOTER //
// ./src/reducers/sales.js